import type { FileWriter } from '@/platform'

export function writeIntBool(writer: FileWriter, value: unknown): void {
  writer.writeInt(value ? 1 : 0)
}

export function normalizeString(value: unknown): string {
  return value == null ? '' : String(value)
}

export function normalizeRuntimeFontName(value: unknown): string {
  const text = normalizeString(value).trim()
  if (!text) return ''
  const lastSegment = text.replace(/\\/g, '/').split('/').pop() || text
  return lastSegment.replace(/\.[^.]+$/i, '')
}
